import { MeasurementUnits } from "../../measurement";
import { RoomViewConfig, roomViewDefaults } from "../../views/views-config";
import { clone, OptionalProperties } from "../../json/optional-properties";

export interface MeasurementUnitsConfig {
    units: MeasurementUnits,
};

export type ViewerConfig = {
    standalone: boolean,
    roomView: RoomViewConfig,
    environmentAssetId: string,
}
export type ViewerOptions = OptionalProperties<ViewerConfig>;

export const viewerDefaults: ViewerConfig = {
    standalone: false,
    roomView: clone(roomViewDefaults),
    environmentAssetId: "environments/studio-01",
}
